// components/modals/AlreadyPurchasedModal.jsx
import React from 'react';
import { Modal } from 'antd';

const AlreadyPurchasedModal = ({ visible, onClose }) => {
  return (
    <Modal
      title="Class Already Purchased"
      open={visible}
      onCancel={onClose}
      onOk={onClose}
      okText="Okay"
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <p>You have already purchased this class. Please check your class list for details.</p>
    </Modal>
  );
};

export default AlreadyPurchasedModal;
